import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'
import { apiV1 } from '../utils/constant';

/**
 * @function getroadcover
 * @desc 西城道路统计
 * @returns {Object}
 */
const getroadcover = (query) => {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/cases_scoring/road_cover?${query}`
    )
    .then(checkResponse)
}

/**
 * @function downloadRoadcover
 * @desc 西城道路统计导出
 * @returns {Object}
 */
const downloadRoadcover = (query) => {
  return axios
    .get(
      `${apiV1}/projects/${getProjectId()}/cases_scoring/road_cover_download?${query}`
    )
    .then(checkResponse)
}

export {
  getroadcover,
  downloadRoadcover
}
